<template>
	<view>
		<view class="user">
			<!-- 头像 -->
			<view class="left">
				<image src="/static/img/head.png" v-if="!user.headerImg"></image>
				<image :src="user.headerImg" v-else></image>
			</view>
			<!-- 昵称,个性签名 -->
			<view class="right">
				<view class="username" v-if="!user.name">请授权登录</view>
				<view class="username" v-else>{{user.name}}</view>
				<view class="font14 fcorfff" v-if="!user.gold">金币: 0</view>
				<view class="font14 fcorfff" v-else>金币: {{user.gold}} 个</view>
				<!-- <view class="signature" @tap="toSetting">{{user.signature}}</view> -->
			</view>
			<!-- 二维码按钮 -->
			<button class="erweima" v-if="user.phone == null" open-type="getPhoneNumber"
				@getphonenumber="getPhoneNumber">
				<image style="width: 50px;height: 50px;" src="data:image/png;base64,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">
				</image>
			</button>
			<button class="erweima" v-else @click="toDeposit">
				<image style="width: 50px;height: 50px;" src="data:image/png;base64,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">
				</image>
			</button>
		</view>
		<!-- 订单-余额 -->
		<view class="order">
			<!-- 订单类型 -->
			<view class="title">我的订单</view>
			<view class="list">
				<view class="box" v-for="(row,index) in orderList" :key="index" @tap="toOrderList(index)">
					<view class="img">
						<view class="icon" :class="row.icon"></view>
					</view>
					<view class="text">{{row.text}}</view>
				</view>
			</view>
		</view>
		<!-- 工具栏 -->
		<view class="toolbar">
			<view class="title">我的工具栏</view>
			<view class="list">
				<view class="box" v-for="(row,index) in mytoolbarList" :key="index" @tap="toPage(row.url)">
					<!-- <view style="width: 10px;height: 10px;">
						<uni-badge  text="1" type="error" />
					</view> -->
					
					<uni-badge style="width: 20px;" v-if="row.text == '我的卡券' " :text="textnum" type="error" size="normal"></uni-badge>
					<view class="img">
						<image :src="row.img"></image>
					</view>
					<view class="text">{{row.text}}</view>
				</view>
			</view>
		</view>
		<!-- 占位 -->
		<view class="place-bottom"></view>
		<authorize></authorize>
	</view>
</template>
<script>
	import {
		GetPhoneNumber,
		findUser
	} from "../../../Utils/Api.js";
	import uniBadge from "../../../components/uni-badge/components/uni-badge/uni-badge.vue";
	let app = getApp()
	import authorize from '../../../components/Authorize';
	export default {
		components: {
			authorize,
			uniBadge
		},
		data() {
			return {
				isfirst: true,
				headerPosition: "fixed",
				textnum : 10,
				headerTop: null,
				statusTop: null,
				showHeader: true,
				//个人信息,
				user: "",
				// 订单类型
				orderList: [{
						text: '待支付',
						icon: "fukuan"
					},
					{
						text: '已支付',
						icon: "fahuo"
					},
					{
						text: '已完成',
						icon: "shouhuo"
					},
					// {
					// 	text: '已退款',
					// 	icon: "pingjia"
					// },
					{
						text: '已取消',
						icon: "pingjia"
					},
				],
				// 工具栏列表
				mytoolbarList: [{
						url: '/pages/goods/recording/recording?id=1',
						text: '充值记录',
						img: '/static/img/user/mingxi.png'
					},
					{
						url: '/pages/goods/recording/recording?id=2',
						text: '消费记录',
						img: '/static/img/user/quan.png'
					},
					{
						url: '/pages/user/mineCoupons/mineCoupons',
						text: '我的卡券',
						img: '/static/img/user/choujiang.png'
					},
					{
						url: '../../login/login',
						text: '商户入口',
						img: '/static/img/user/point.png'
					}

				]
			}
		},
		//下拉刷新，需要自己在page.json文件中配置开启页面下拉刷新 "enablePullDownRefresh": true
		onPullDownRefresh() {
			setTimeout(function() {
				uni.stopPullDownRefresh();
			}, 1000);
		},
		onPageScroll(e) {
			//兼容iOS端下拉时顶部漂移
			this.headerPosition = e.scrollTop >= 0 ? "fixed" : "absolute";
			this.headerTop = e.scrollTop >= 0 ? null : 0;
			this.statusTop = e.scrollTop >= 0 ? null : -this.statusHeight + 'px';
		},
		onLoad() {
			this.statusHeight = 0;
		},
		onReady() {
			//此处，演示,每次页面初次渲染都把登录状态重置
			uni.setStorage({
				key: 'UserInfo',
				data: false,
				success: function() {},
				fail: function(e) {}
			});
		},
		onShow() {
		if (app.globalData.userInfo) {
			this.findUser();
			}
		},
		methods: {
			findUser() {
				let params;
				findUser(params).then(res => {
					if (res.return_code == '000000') {
						app.globalData.userInfo = res.return_data;
						this.user = res.return_data;
						uni.setStorage({
							key: "user",
							data: res.return_data
						})
					}
				});
			},
			getPhoneNumber(PhoneNumber) {
				let params = {
					openId: app.globalData.openId,
					iv: PhoneNumber.detail.iv,
					encryptedData: PhoneNumber.detail.encryptedData
				}
				GetPhoneNumber(params).then(res => {
					if (res.return_code == '000000') {
						app.globalData.userInfo = res.return_data
							.object
							.highUser;
						uni.setStorage({
							key: "user",
							data: res.return_data
								.object
								.highUser
						})
						this.toDeposit();
					}
				});
			},
			//消息列表
			toMsg() {
				// uni.navigateTo({
				// 	url:'../../msg/msg'
				// })
				uni.showToast({
					title: '暂未开通',
					icon: 'none'
				});
			},
			toOrderList(index) {
				uni.navigateTo({
					url: '../../user/order_list/order_list?tbIndex=' + index
				})
			},
			// toSetting() {
			// 	uni.navigateTo({
			// 		url: '../../user/setting/setting'
			// 	})
			// },
			toMyQR() {
				uni.navigateTo({
					url: '../../user/myQR/myQR'
				})
			},
			toLogin() {
				uni.showToast({
					title: '请登录',
					icon: "none"
				});
				uni.navigateTo({
					url: '../../login/login'
				})
				this.isfirst = false;
			},
			isLogin() {
				//实际应用中,用户登录状态应该用token等方法去维持登录状态.
				const value = uni.getStorageSync('UserInfo');
				if (value) {
					return true;
				}
				return false
			},
			toDeposit() {
				uni.navigateTo({
					url: '../../user/deposit/deposit'
				})
			},
			toPage(url) {
				if (!url) {
					uni.showToast({
						title: '模板未包含此页面',
						icon: "none"
					});
					return;
				}
				uni.navigateTo({
					url: url
				})
			}
		}
	}
</script>
<style lang="scss">
	page {
		position: relative;
		background-color: #fff;
	}

	.status {
		width: 100%;
		height: 0;
		position: fixed;
		z-index: 10;
		background-color: #f06c7a;
		top: 0;
		/*  #ifdef  APP-PLUS  */
		height: var(--status-bar-height); //覆盖样式
		/*  #endif  */

	}

	.header {
		width: 92%;
		padding: 0 4%;
		height: 100upx;
		display: flex;
		justify-content: flex-end;
		align-items: center;
		position: fixed;
		top: 0;
		z-index: 10;
		background-color: #f06c7a;
		/*  #ifdef  APP-PLUS  */
		top: var(--status-bar-height);

		/*  #endif  */
		.icon-btn {
			width: 120upx;
			height: 60upx;
			flex-shrink: 0;
			display: flex;

			.icon {
				color: #fff;
				width: 60upx;
				height: 60upx;
				display: flex;
				justify-content: flex-end;
				align-items: center;
				font-size: 42upx;
			}
		}
	}

	.place {
		background-color: #f06c7a;
		height: 100upx;
		/*  #ifdef  APP-PLUS  */
		margin-top: var(--status-bar-height);
		/*  #endif  */
	}

	.place-bottom {
		height: 300upx;
	}

	.user {
		width: 92%;
		padding: 0 4%;
		display: flex;
		align-items: center;
		// position: relative;
		background-color: #f06c7a;
		padding-bottom: 40rpx;

		.left {
			width: 20vw;
			height: 20vw;
			flex-shrink: 0;
			margin-right: 20upx;
			border: solid 1upx #fff;
			border-radius: 100%;

			image {
				width: 20vw;
				height: 20vw;
				border-radius: 100%;
			}

		}

		.right {
			width: 100%;

			.username {
				font-size: 36upx;
				color: #fff;
			}

			.signature {
				color: #eee;
				font-size: 28upx;
			}
		}

		.erweima {
			flex-shrink: 0;
			width: 50px;
			height: 50px;
			padding: 0;
			margin-left: 5vw;
			border-radius: 100%;
			display: flex;
			justify-content: center;
			align-items: center;
			background: linear-gradient(to left, #fbbb37 0%, #fcf0d0 105%);

			.icon {
				color: #7b6335;
				font-size: 42upx;
			}
		}
	}

	.order {
		.title {
			padding-top: 10upx;
			margin: 0 0 10upx 3%;
			font-size: 30upx;
			height: 80upx;
			display: flex;
			align-items: center;
		}

		width: 92%;
		margin: 30rpx 4% 30rpx 4%;
		padding: 0rpx 0% 20rpx 0%;
		background-color: #fff;
		box-shadow: 0rpx 0rpx 25rpx rgba(0, 0, 0, 0.1);
		border-radius: 15rpx;

		.list {
			display: flex;
			padding-bottom: 10upx;

			.box {
				width: 25%;

				.img {
					width: 100%;
					display: flex;
					justify-content: center;

					.icon {
						font-size: 50upx;
						color: #464646;
					}
				}

				.text {
					width: 100%;
					display: flex;
					justify-content: center;
					font-size: 28upx;
					color: #3d3d3d;
				}
			}
		}

		.balance-info {
			display: flex;
			padding: 10upx 0;

			.left {
				width: 75%;
				display: flex;

				.box {
					width: 50%;
					font-size: 28upx;

					.num {
						width: 100%;
						height: 50upx;
						display: flex;
						justify-content: center;
						align-items: flex-end;
						color: #f9a453;
					}

					.text {
						width: 100%;
						display: flex;
						justify-content: center;
						color: #3d3d3d;
						font-size: 28upx;
					}
				}
			}

			.right {
				border-left: solid 1upx #17e6a1;
				width: 25%;

				.box {

					.img {
						width: 100%;
						height: 50upx;
						display: flex;
						justify-content: center;
						align-items: flex-end;

						.icon {
							font-size: 45upx;
							color: #e78901;
						}
					}

					.text {
						width: 100%;
						display: flex;
						justify-content: center;
						font-size: 28upx;
						color: #3d3d3d;
					}
				}
			}
		}
	}

	.VIP {
		width: 84%;
		margin: -65upx auto 20upx auto;
		padding: 30upx 4%;
		background: linear-gradient(to left, #dea96d 0%, #f6d59b 100%);
		box-shadow: 0upx 0upx 25upx rgba(0, 0, 0, 0.2);
		border-radius: 15upx;
		display: flex;
		align-items: center;

		.img {
			flex-shrink: 0;
			width: 60upx;
			height: 60upx;

			image {
				width: 60upx;
				height: 60upx;
			}
		}

		.title {
			width: 100%;
			color: #796335;
			font-size: 30upx;
		}

		.tis {
			width: 100%;
			display: flex;
			justify-content: flex-end;
			color: #fcf0d0;
			font-size: 26upx;
		}
	}

	.toolbar {
		width: 92%;
		margin: 0 4% 0 4%;
		padding: 0 0 20upx 0;
		background-color: #fff;
		box-shadow: 0upx 0upx 25upx rgba(0, 0, 0, 0.1);
		border-radius: 15upx;

		.title {
			padding-top: 10upx;
			margin: 0 0 10upx 3%;
			font-size: 30upx;
			height: 80upx;
			display: flex;
			align-items: center;
		}

		.list {
			display: flex;
			flex-wrap: wrap;

			.box {
				width: 25%;
				margin-bottom: 30upx;

				.img {
					width: 23vw;
					height: 10.5vw;
					display: flex;
					justify-content: center;

					image {
						width: 9vw;
						height: 9vw;
					}
				}

				.text {
					width: 100%;
					display: flex;
					justify-content: center;
					font-size: 26upx;
					color: #3d3d3d;
				}
			}
		}
	}
</style>
